/* eslint-disable react/no-danger */
import React, { Component } from 'react'
import cx from 'classnames'
import SVG from '../SVG'
import { subString, getRealStringLength } from '../../utils/string'
import arrowDownIcon from '../../assets/icon-arrow-down.svg'
import styles from './index.css'

export default class TextToggle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: Boolean(props.expanded),
    }
  }

  handleExpand = () => {
    this.setState({ expanded: true })
  }

  handleShrink = () => {
    this.setState({ expanded: false })
  }

  render() {
    const { expanded } = this.state
    const {
      className,
      content = '',
      minLength = 40,
      toggleButtonText,
    } = this.props
    const pureText = content.replace(/<[^>]*>/g, ' ')
    const desc = subString(pureText, minLength)
    const canToggle = minLength < getRealStringLength(pureText)

    return (
      <div
        className={cx(
          styles.textToggle,
          { [styles.textToggleCanToggle]: canToggle && toggleButtonText },
          className
        )}
      >
        {Boolean(!canToggle || (canToggle && expanded)) && (
          <div
            className={styles.textToggleText}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        {canToggle &&
          !expanded && <div className={styles.textToggleText}>{desc}...</div>}
        {canToggle &&
          toggleButtonText && (
            <div
              className={
                expanded ? styles.textShrinkButton : styles.textExpandButton
              }
              onClick={expanded ? this.handleShrink : this.handleExpand}
            >
              {expanded ? '收起' : '展开'}
              {toggleButtonText}
              <SVG src={arrowDownIcon} width={9} height={5} />
            </div>
          )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TextToggle/index.js